const getMenu = (state) => state.menu;
const menuShown = (state) => state.menu.show;

export { getMenu, menuShown };
